export const environment = {
  production: true,
  api: {
    uri: `https://back.formateur.argalis.fr`,
    identifier: null, // Identifier initialisé dans libs/angular-global/src/lib/services/config/config.service.ts(19:7)
    captchaKey: '6Ld2agcUAAAAAKq2lBRDPemG2B4SPaUOeYKU4o-F',
  },
  signatureBaseUrl: 'https://signature.argalis.fr',
};
